// // assets
// import { DashboardOutlined } from '@ant-design/icons';

// // icons
// const icons = {
//   DashboardOutlined
// };

// // ==============================|| MENU ITEMS - DASHBOARD ||============================== //

// const dashboard = {
//   id: 'group-dashboard',
//   title: 'Home',
//   type: 'group',
//   children: [
//     {
//       id: 'dashboard',
//       title: 'Dashboard',
//       type: 'item',
//       url: '/',
//       icon: icons.DashboardOutlined,
//       breadcrumbs: false
//     }
//   ]
// };

// export default dashboard;



// assets
import { HomeOutlined, DashboardOutlined } from '@ant-design/icons';

// icons
const icons = {
  HomeOutlined,
  DashboardOutlined 
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Home',
  type: 'collapse',
  icon: icons.HomeOutlined,
  roles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9 ,10, 11, 12], 
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/',
      icon: icons.DashboardOutlined,
      roles: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9 ,10, 11, 12]
    }
  ]
};

export default dashboard;
